import type { UserRoleEnum } from '..'

export enum EmunTeamStatus {
    ACTIVE = 'active',
    BUZY = 'busy',
    INACTIVE = 'inactive',
}

export type TeamStatusType = `${EmunTeamStatus}`
export interface ITeamManagmant {
    team: ITeamOne
    totalUsers: number
    randomUsers: any[]
}

export interface ITeamOne {
    id: number
    name: string
    tenantId: number
    leadId: number
    status: string
    createdAt: Date
    updatedAt: Date
    lead: ITeamMember
    members: ITeamMember[]
}

export interface ITeamMember {
    id: number
    fullName: string
    email: string
    photo: string
    roles: UserRoleEnum[]
}

export interface ITeamForm {
    name?: string
    leadId?: number
    status?: TeamStatusType
    members?: number[]
}
